import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { authApi } from '../../api/authApi';

export default function LoginPage() {
  const { setToken } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const loc = useLocation() as { state?: { from?: string } };
  const backTo = loc.state?.from ?? '/dashboard';

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    if (!email.trim() || !password) {
      setError('Inserisci email e password');
      return;
    }
    setLoading(true);
    try {
      const res = await authApi.login(email.trim(), password) as any;
      const token = res?.accessToken ?? res?.token;
      const userData = res?.user;
      if (!token) throw new Error('Risposta non valida dal server');
      setToken(token, userData ? { id: userData.id, email: userData.email, fullName: userData.fullName, role: userData.role } : null);
      nav(backTo, { replace: true });
    } catch (err: any) {
      const msg = err?.message ?? 'Login fallito';
      setError(msg.includes('401') || msg.includes('Credenziali') ? 'Email o password errati' : msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-card-header">
          <div className="auth-card-logo">
            <i className="bi bi-grid-3x3-gap-fill" />
          </div>
          <h1 className="auth-card-title">Accedi</h1>
          <p className="auth-card-subtitle">Inserisci le tue credenziali per accedere al gestionale</p>
        </div>

        <div className="auth-card-body">
          <form onSubmit={submit} className="auth-form">
            <div className="mb-3">
              <label htmlFor="login-email" className="form-label">Email</label>
              <input
                id="login-email"
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="es. admin@nat.local"
                autoComplete="email"
                autoFocus
              />
            </div>
            <div className="mb-3">
              <label htmlFor="login-password" className="form-label">Password</label>
              <input
                id="login-password"
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                autoComplete="current-password"
              />
            </div>
            {error && (
              <div className="alert alert-danger auth-alert mb-3" role="alert">
                <i className="bi bi-exclamation-circle me-2" />
                {error}
              </div>
            )}
            <button
              className="btn auth-btn-primary mb-0"
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Accesso in corso...
                </>
              ) : (
                <>
                  <i className="bi bi-box-arrow-in-right me-2" />
                  Accedi
                </>
              )}
            </button>
          </form>

          <div className="auth-links text-center">
            <p className="mb-2">
              <Link to="/forgot-password">Password dimenticata?</Link>
            </p>
            <p className="mb-0 text-muted small">
              Non hai un account?{' '}
              <Link to="/register" state={loc.state}>Registrati</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
